import { useEffect } from 'react';

class ActionEvent<Payload = undefined> extends Event {
    constructor(
        name: string,
        readonly payload?: Payload
    ) {
        super(`stateofourcity.action.${name}`);
    }
}
export function useActionHandler<T = undefined>(
    name: string,
    handler: (payload?: T) => void
) {
    useEffect(() => {
        const eventName = `stateofourcity.action.${name}`;

        const listener = (event: Event) => {
            if (event instanceof ActionEvent) {
                handler();
            } else {
                console.warn(`Expected ActionEvent, got ${event}, ignoring`);
            }
        };

        window.addEventListener(eventName, listener);

        return () => {
            window.removeEventListener(eventName, listener);
        };
    }, [name]);
}

export function useActionTrigger<Payload = undefined>(name: string) {
    return (payload?: Payload) => {
        const event = new ActionEvent(name, payload);

        window.dispatchEvent(event);
    };
}
